import { CloseButton, Flex } from "@chakra-ui/react";
import * as React from "react";

interface Props {
  isOpen?: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
}

export const MobileNavContent: React.FC<Props> = (props) => {
  const { isOpen, onClose, children } = props;
  const bg = "white";
  if (!isOpen) return null;
  return (
    <Flex
      direction="column"
      w="100%"
      bg={bg}
      h="100vh"
      overflow="auto"
      pos="absolute"
      top={0}
      left={0}
      zIndex={20}
      px={4}
      py={4}
    >
      {children}
      <CloseButton pos="absolute" top={4} right={4} onClick={onClose} />
    </Flex>
  );
};
